import React, { FunctionComponent, useState } from 'react'
import styles from './ReferralUrl.module.css'
import images from '../../../assets/images';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { affiliateById, affiliateViewById } from '../table/TableHelper';

interface props{
    referralDetail: affiliateViewById | undefined;
    handleCloseReferralDialog: () => void
}
const ReferralUrl: FunctionComponent<props> = ({referralDetail,handleCloseReferralDialog}) => {
    const {CloseIcon} = images;
    const [copied,setCopied] = useState<boolean>(false);
    const handleCopy = () => {
        setCopied(true);
        setTimeout(()=> {
          setCopied(false);
        },2000)
    }
  return (
    <div className={styles.ReferralUrlPopup}>
        <div className={styles.topSection}>
            <div className={styles.titleStyle}> Referral Url</div>
            <div><img alt='closeIcon' src={CloseIcon} className={styles.closeIconStyle} onClick={handleCloseReferralDialog}/></div>
        </div>
        <div className={styles.affiliateDetails}>
            <div className={styles.detailsTitle}>Affiliate Details</div>
            <div className={styles.details}>
                <div className={styles.firstName}>
                    <div className={styles.subTitle}>First Name</div>
                    <div>{referralDetail?.firstName}</div>
                </div>
                <div className={styles.lastName}>
                    <div className={styles.subTitle}>Last Name</div>
                    <div>{referralDetail?.lastName}</div>
                </div>
                <div className={styles.email}>
                    <div className={styles.subTitle}>Email</div>
                    <div>{referralDetail?.emailId}</div>
                </div>
            </div>
        </div>
        <div className={styles.bottomSection}>
            <div className={styles.referralTitle}>Referral Url</div>
            <div className={styles.urlBlock}>
                <div className={styles.URLStyle}>URL</div>
                <div className={styles.linkblock}>
                    <div className={styles.link}>{referralDetail?.referralUrl}</div>
                    <CopyToClipboard text={referralDetail?.referralUrl as string} onCopy={handleCopy}>
                          { copied
                           ?  <div className={styles.copyText}>Copied</div>
                           :  <div className={styles.copyText}>Copy Url</div>
                          }
                    </CopyToClipboard>
                </div>
            </div>
        </div>
    </div>
  )
}

export default ReferralUrl; 
